import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "header-inner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "nav" }

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { Modal } from 'ant-design-vue'
import { getToken } from '@/utils/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const router = useRouter()
const logoSrc = computed(() => require('@/assets/logo2.png'))

const checkLoginAndNavigate = (path: string) => {
  const token = getToken()
  if (!token) {
    Modal.confirm({
      title: '提示',
      content: '您还未登录，是否前往登录？',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        window.location.href = 'https://portal.zjzwfw.gov.cn/uc/sso/login?appId=A330206283372202210017392&userType=person&sp=https://lxsh.bl.cn/lxcf-pc?from=zqykt'
      }
    })
  } else {
    router.push(path)
  }
}

const handlePushClick = (e: Event) => {
  e.preventDefault()
  e.stopPropagation()
  checkLoginAndNavigate('/push')
}

const handleUserClick = (e: Event) => {
  e.preventDefault()
  e.stopPropagation()
  checkLoginAndNavigate('/user')
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "brand",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
      }, [
        _createElementVNode("img", {
          class: "brand-logo",
          src: logoSrc.value,
          alt: "logo"
        }, null, 8, _hoisted_3),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "brand-name" }, "仑享厂房", -1))
      ]),
      _createElementVNode("nav", _hoisted_4, [
        _createVNode(_component_RouterLink, {
          class: "nav-link",
          to: "/"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("出租房源")
          ])),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          class: "nav-link",
          to: "/rental-demand"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("求租房源")
          ])),
          _: 1
        }),
        _createElementVNode("span", {
          class: "nav-link",
          onClick: handlePushClick
        }, "发布房源"),
        _createVNode(_component_RouterLink, {
          class: "nav-link",
          to: "/recommend"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("智能推荐")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", { class: "actions" }, [
        _createElementVNode("span", {
          class: "action-link",
          onClick: handleUserClick
        }, "个人中心")
      ])
    ])
  ]))
}
}

})